
import React, { Component}  from 'react';

import { DetailProvider, DetailContext } from 'core/DetailProvider';
import { FormContext, FormProvider } from 'core/FormProvider';
import { YellowButton } from 'ui/Button';
import { ServiceForm } from './Form';
import Layout from 'components/Dashboard/Layout';


export default class ServiceFormDetail extends Component {

  onLoaded = (item) => {
    document.title = `Услуга ${item.name}`;
  };

  render() {
    const { match } = this.props;
    return (
      <DetailProvider
        url={`catalog/service/${match.params.id}`}
        onLoaded={(item) => this.onLoaded(item)}
      >
        <DetailContext.Consumer>
          {detailContext => {
            let { item } = detailContext;
            return (
              <FormProvider
                url={item.meta.url}
                postSaveMessage={'Услуга обновлена'}
                postSave={(item) => detailContext.updateItem(item)}
                item={item}
              >
                <FormContext.Consumer>
                {formContext => {
                  const { loading } = formContext;
                  return (
                    <Layout>
                      <Layout.Header
                        title={'Редактирование услуги'}
                        backUrl={'/service'}
                      />

                      <Layout.ContentSimple>
                        <ServiceForm />

                        <div className={'mt-30'}>
                          <YellowButton
                            onClick={(e) => formContext.handleSubmit(e)}
                            disabled={loading}
                            size={'large'}
                          >
                            Обновить услугу
                          </YellowButton>
                        </div>
                      </Layout.ContentSimple>

                    </Layout>
                  )
                }}
                </FormContext.Consumer>
              </FormProvider>
            )
          }}
        </DetailContext.Consumer>
      </DetailProvider>
    )
  }
}
